module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "book-disabled.8a6e0d20.png";